import type { Fallacy } from "./types";
import { createStory } from "./types";

export const whataboutism: Fallacy = {
    id: "whataboutism",
    name: "Whataboutism",
    emoji: "👉",
    category: "Menyerang Lawan",
    description:
      "Membalas kritik dengan **mengalihkan ke kesalahan pihak lain**. 'Tapi gimana dengan X yang juga salah?'",
    tldr: "'Tapi yang lain juga salah!' — itu whataboutism, bukan jawaban.",
    detail:
      "Whataboutism adalah taktik **mengalihkan kritik** dengan menunjuk **kesalahan pihak lain**, tanpa menjawab kritik yang disampaikan. Mirip Tu Quoque, tapi lebih luas — bisa menunjuk ke pihak ketiga mana pun.\n\nPola: A mengkritik X, B membalas \"Tapi gimana dengan Y?\", dan kritik terhadap X tidak pernah dijawab.\n\nKenapa ini fallacy? Karena **kesalahan pihak lain tidak menghapus atau membenarkan** kesalahan yang sedang dibahas. Dua hal bisa salah secara bersamaan.\n\nCara melawan: \"Ya, itu juga masalah. Tapi sekarang kita sedang membahas X. Mari fokus dulu ke sini.\"",
    story: createStory("Whataboutism", "👉", {
      hook: {
        title: "Kamu kritik sesuatu.",
        body: "Tapi bukannya dijawab, malah dibalik: \"Tapi yang lain juga salah!\" Kamu pernah digituin?",
      },
      convo: {
        claim: "Kinerja gubernur soal banjir ini mengecewakan, udah 3 tahun janji hasilnya nol. Tapi yang didenger cuma **\"emang gubernur sebelumnya lebih bagus? Dulu juga banjir kok!\"**",
        response: "Kritik yang sekarang dialihkan ke masa lalu. **Pertanyaan awalnya gak pernah dijawab.**",
      },
      reveal: {
        body: "Ngalihin kritik dengan nunjuk **kesalahan pihak lain**. Kritik yang asli **gak pernah dijawab** — cuma dialihkan.",
      },
      insight: {
        title: "Yang penting diingat:",
        body: "**Dua hal bisa salah secara bersamaan.** Kesalahan orang lain bukan pembenaran buat kesalahan yang lagi dibahas.",
      },
      engagement: {
        title: "Paling sering kena whataboutism soal apa?",
        body: "Politik atau urusan rumah tangga? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["tu-quoque", "red-herring", "ad-hominem"],
  };
